import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import MultipleSelectComponent from './MultipleSelectComponent';

import StyledSelect from '../Select';

const StyledContainer = styled(Box)(({ theme }) => ({
  minWidth: '15rem',
  height: '4rem',
  [theme.breakpoints.up('xs')]: {
    width: '48%',
  },
  [theme.breakpoints.up('md')]: {
    width: '32%',
  },
  [theme.breakpoints.up('lg')]: {
    width: '19%',
  },
}));

const FilterSelectComponent = (props) => {
  const {
    onChange,
    filterValues,
    filter: {
      value,
      options,
      sortAlphabetically,
      key,
      defaultValue,
      multi,
      placeholder,
      isClearable,
      isMultiWithCheckbox,
      width,
    },
    isLoading,
  } = props;

  useEffect(() => {
    onChange && defaultValue && onChange(defaultValue);
  }, []);

  let selectValue = value || filterValues?.[key] || defaultValue || null;
  if (multi && !selectValue) {
    selectValue = [];
  }

  return (
    <StyledContainer>
      {isMultiWithCheckbox ? (
        <MultipleSelectComponent
          multi={multi}
          options={options}
          onChange={onChange}
          selectValue={selectValue}
          placeholder={placeholder}
          width={width}
        />
      ) : (
        <StyledSelect
          value={selectValue}
          onChange={(event, newValue) => {
            // for the multi select an array of values with the [{ label, value }] structure
            // should be converted to the comma separated list of values like 1,2,3
            const value = multi
              ? newValue?.map(({ value }) => value)?.join(',')
              : newValue?.value;

            onChange(value);
          }}
          options={options}
          multiple={multi}
          disableClearable={!isClearable}
          placeholder={placeholder}
          disabled={isLoading}
          filterSelectedOptions={multi}
          sortAlphabetically={sortAlphabetically}
        />
      )}
    </StyledContainer>
  );
};

FilterSelectComponent.defaultProps = {
  filter: null,
  onChange: () => {},
  filterValues: null,
  isClearable: false,
  isLoading: false,
};

FilterSelectComponent.propTypes = {
  filter: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  filterValues: PropTypes.instanceOf(Object),
  isClearable: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default FilterSelectComponent;
